import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
import moment from "moment";
import visionLogo from "../../images/vision-logo.png";
import { mergePdfs } from "../helpers/pdfs";
import { formatAmount } from "../helpers/common";

const generatePDF = async (priceData) => {
    const doc = new jsPDF('p', 'mm', 'a4');

    // Logo
    doc.addImage(visionLogo, "PNG", 8, 7, 44, 12);
    doc.setFontSize(16);
    doc.text("Price List - Vision", 200, 12, { align: "right" })

    doc.setFontSize(12);
    doc.setTextColor("#787a80")
    doc.text(`Agent: ${priceData.CustomerCode}`, 15, 28);
    doc.text(`Date: ${moment(priceData.OrderDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}`, 200, 28, { align: "right" });
    doc.setTextColor("#252527");

    // Product Details Table
    const products = priceData?.products;

    let productsHead = [["Qty", "Crate", "Count", "Price"]];

    productsHead[0].splice(0, 0, { content: "VisionProduce", colSpan: 2, fontStyle: "bold" });

    autoTable(doc, {
        startY: 32,
        columnStyles: {
            0: { cellWidth: 26, halign: "left" },
            1: { cellWidth: 90, halign: "left" },
            2: { cellWidth: 18, halign: "center" },
            3: { cellWidth: 18, halign: "center" },
            4: { cellWidth: 18, halign: "center" },
            5: { cellWidth: 20, halign: "right" },
        },
        head: productsHead,
        body: products.map((product, productIndex) => {
            let qtyUnitName = `${product.Qty} ${product.UnitName}`
            return ([product.UnitName, product.ProductName, product.Qty, product.ContainerName, product.Count, formatAmount(product.SellPrice)])
        }),
        theme: "grid",
        headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            lineWidth: 0.2
        },
        styles: { fontSize: 10 },
        margin: { top: 8, bottom: 10, left: 10, right: 10 },
        showHead: "firstPage",
        showFoot: "lastPage",
        footStyles:{
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
        },
        foot: [[{ content: `Item Count : ${products.length}`, colSpan: 6, styles : {fontStyle: "bold", fontSize:12, halign: "right"}}]]
    });

    // Check End of the Page and Move to new page if there no required space left.
    let yPosition = doc.lastAutoTable.finalY + 5;
    const pageHeight = doc.internal.pageSize.height;

    if (yPosition > pageHeight) {
        doc.addPage();
        yPosition = 10;
    }

    // Footer Pagination
    const totalPageCount = doc.internal.pages.length - 1;

    for (let i = 1; i <= totalPageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor("#787a80")
        const currentDate = moment().format("DD MMMM, YYYY")
        const pageText = `Page ${i} of ${totalPageCount}`;
        const visionText = `VISION PRODUCE`;
        if (i === totalPageCount) {
            doc.setDrawColor(0);
            doc.setLineWidth(0.5);
            doc.line(10, doc.internal.pageSize.height - 10, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);
            doc.text(
                currentDate,
                doc.internal.pageSize.getWidth() - 200,
                doc.internal.pageSize.getHeight() - 5,
            );
            doc.text(
                visionText,
                doc.internal.pageSize.getWidth() - 110,
                doc.internal.pageSize.getHeight() - 5,
            );
        }
        doc.text(
            pageText,
            doc.internal.pageSize.getWidth() - 25,
            doc.internal.pageSize.getHeight() - 5,
        );
    }

    return doc.output("arraybuffer");
}

export const generatePriceListPdf = async (priceDataArray, isEmail = false) => {
    const pdfs = [];
    for (const ele of priceDataArray) {
        const doc = await generatePDF(ele);
        pdfs.push(doc);
    }

    const mergedPdf = await mergePdfs(pdfs);
    if (isEmail) {
        return mergedPdf;
    }
    const blob = new Blob([mergedPdf], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
}